// Created by kdw0601 on 2022-12-29
import { useEffect, useRef, useState } from 'react';
import List, { MultipleVariant, SingleVariant } from './List';
import styles from './List.module.scss';
import classNames from 'classnames/bind';
import ListOption from './ListOption';
import React from 'react';

const cx = classNames.bind(styles);

interface Props<T> extends ListOption<T> {
  onClick: (val: T) => void;
  variant?: SingleVariant | MultipleVariant;
  selected?: boolean;
}

const ListItem = <T,>({
  disabled,
  name,
  color,
  subText,
  value,
  hidden,
  onClick,
  variant,
  selected,
  subMenu,
}: Props<T>) => {
  const [isMounted, setIsMounted] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [subMenuDirection, setSubMenuDirection] = useState('right');
  useEffect(() => {
    if (!subMenu) return;

    const handler = () => {
      const rect = wrapperRef.current?.getBoundingClientRect();
      const openSubMenuLeft = rect ? window.innerWidth - rect.right - rect.width - 10 < 0 : false;
      setSubMenuDirection(openSubMenuLeft ? 'left' : 'right');
    };

    handler();
    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [subMenu]);

  // 선택된 항목일 시 포커스
  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
      return;
    }

    if (!variant?.startsWith('check') && selected) {
      buttonRef.current?.focus();
    }
  }, [isMounted]);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (subMenu) return;
    onClick(value);
  };

  if (hidden) return null;

  return (
    <div className={cx('item-wrapper')} ref={wrapperRef}>
      <button
        onMouseOver={(e) => {
          e.stopPropagation();
          e.currentTarget.focus();
        }}
        ref={buttonRef}
        className={cx('item', subMenu && 'has-sub-menu', selected && 'selected')}
        disabled={disabled}
        style={{ color }}
        onClick={handleClick}
      >
        <div className={cx('name-wrap')}>
          {variant?.endsWith('sub') && subText && <div className={cx('sub')}>{subText}</div>}
          <div className={cx('name')}>{name}</div>
        </div>
      </button>
      {subMenu && <List options={subMenu} className={cx('sub-menu', subMenuDirection)} onChange={onClick} />}
    </div>
  );
};

export default ListItem;
